/**
 * Users API Utility Functions
 * Common utility functions for users API operations
 */

import { getAuthConfigFromStore } from '../../auth/authUtils';

/**
 * Check if users API is ready (authentication configured)
 * @returns True if authentication is configured
 */
export function isUsersApiReady(): boolean {
  return getAuthConfigFromStore() !== null;
}

/**
 * Validate email format for invitations
 * @param email - Email address to validate
 * @returns Error message if invalid, null if valid
 */
export function validateInvitationEmail(email: string): string | null {
  if (!email || email.trim().length === 0) {
    return 'Email is required';
  }
  
  // Basic email format validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return 'Invalid email format';
  }
  
  if (email.length > 254) {
    return 'Email address is too long';
  }
  
  return null;
}

/**
 * Validate user type
 * @param userType - User type to validate
 * @returns Error message if invalid, null if valid
 */
export function validateUserType(userType: string): string | null {
  if (!userType) {
    return 'User type is required';
  }
  
  if (!['SubMaster', 'User'].includes(userType)) {
    return 'Invalid user type. Must be "SubMaster" or "User"';
  }
  
  return null;
}

/**
 * Validate login app
 * @param loginApp - Login app to validate
 * @returns Error message if invalid, null if valid
 */
export function validateLoginApp(loginApp: string): string | null {
  if (!loginApp) {
    return 'Login app is required';
  }
  
  if (!['fleeta', 'blackvue'].includes(loginApp)) {
    return 'Invalid login app. Must be "fleeta" or "blackvue"';
  }
  
  return null;
}